const enum IFrameQueryParam {
  EVENT_ID = "eid",
  DIVISION_ID = "did",
  TITLE = "title",
  CONTAINER_HEIGHT = "height",
  IFRAME_PARENT_URL = "p_url",
  PERSONATECH_REG_URL = "pt_url",
  THEME = "theme"
}

export default IFrameQueryParam;
